import { useState } from 'react';
import { API } from '../service/ProductsService';
import { TERMS_VERSION, TERMS_UPDATED } from '../legal/siteInfo';

// משתמש מחובר שעוד לא אישר את הגרסה הנוכחית של תנאי השימוש (נרשם לפני שהיו תנאים, או שהתנאים עודכנו -
// TERMS_VERSION ב-siteInfo.js). חייב לאשר כדי להמשיך כמשתמש מחובר; "יציאה" מנתקת (אפשר להמשיך לחפש בלי חשבון).
// onAccepted(termsVersion) / onLogout - ZolBakfarApp.

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', zIndex: 300 },
  dialog:  { width: '100%', maxWidth: 460, background: '#fff', borderRadius: 14, padding: 22, boxShadow: '0 16px 48px rgba(0,0,0,.25)' },
  title:   { margin: '0 0 10px', fontSize: 20, fontWeight: 700 },
  text:    { margin: '0 0 12px', color: '#1f2328', lineHeight: 1.6 },
  check:   { display: 'flex', alignItems: 'center', gap: 8, margin: '14px 0', cursor: 'pointer' },
  actions: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  primary: { flex: 1, padding: '11px 18px', fontSize: 16, fontWeight: 700, border: 'none', borderRadius: 10, background: '#1a3f9c', color: '#fff' },
  secondary: { padding: '10px 16px', fontSize: 15, fontWeight: 600, border: '1px solid #d0d7de', borderRadius: 10, background: '#fff', color: '#1f2328' },
  error:   { background: '#fff1f0', border: '1px solid #ffccc7', color: '#a8071a', padding: '9px 12px', borderRadius: 10, marginBottom: 12, fontSize: 14 },
};

const TermsUpdateDialog = ({ firstTime, onAccepted, onLogout }) => {
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const accept = async () => {
    if (!checked) { setError('יש לסמן שקראת ואת/ה מסכים/ה לתנאים'); return; }
    setSaving(true);
    setError(null);
    try {
      const resp = await API.acceptTerms(TERMS_VERSION);
      const status = resp?.[0]?.[0];
      if (status?.code === 0) onAccepted(resp[1]?.[0]?.termsVersion ?? TERMS_VERSION);
      else if (status?.code !== 90) setError(status?.msg || 'שגיאה, נסו שוב');
    } catch (err) {
      setError('אין חיבור לשרת, נסו שוב');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={s.overlay}>
      <div style={s.dialog} role="dialog" aria-modal="true" aria-labelledby="terms-update-title" aria-describedby="terms-update-text">
        <h2 id="terms-update-title" style={s.title}>{firstTime ? 'תנאי השימוש באתר' : 'עדכנו את תנאי השימוש'}</h2>
        <p id="terms-update-text" style={s.text}>
          {firstTime
            ? 'כדי להמשיך להשתמש בחשבון יש לאשר את תנאי השימוש ומדיניות הפרטיות של האתר.'
            : `תנאי השימוש ומדיניות הפרטיות עודכנו (${TERMS_UPDATED}). כדי להמשיך להשתמש בחשבון יש לאשר אותם.`}
        </p>
        {error && <div style={s.error} role="alert">{error}</div>}
        <label style={s.check}>
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: 18, height: 18 }} />
          <span>
            קראתי ואני מסכים/ה ל<a href="/terms" target="_blank" rel="noopener noreferrer">תנאי השימוש</a>{' '}
            ול<a href="/privacy" target="_blank" rel="noopener noreferrer">מדיניות הפרטיות</a>
          </span>
        </label>
        <div style={s.actions}>
          <button type="button" style={s.primary} onClick={accept} disabled={saving}>{saving ? 'שומר…' : 'אישור והמשך'}</button>
          <button type="button" style={s.secondary} onClick={onLogout} disabled={saving}>יציאה מהחשבון</button>
        </div>
      </div>
    </div>
  );
};

export default TermsUpdateDialog;
